// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__12cVl","container":"styles_container__bhu29","title":"styles_title__2CN43","wrapper":"styles_wrapper__1x5v6","answer":"styles_answer__1_yA6"};